<div class="modal">
   <div class="modal-body">
      <ng-content></ng-content>
   </div>
</div>
<div class="modal-background"></div>
